export function extractFieldRuleMap(ruleJson) {
  if (!ruleJson || !ruleJson.rules || !Array.isArray(ruleJson.rules)) {
    return {};
  }

  const result = {};

  const traverseRules = (rules) => {
    if (!Array.isArray(rules)) return;

    rules.forEach((rule) => {
      if (rule.rules && Array.isArray(rule.rules)) {
        traverseRules(rule.rules);
      }

      if (rule.field && rule.condition) {
        const fieldRule = {
          condition: rule.condition,
          groupName: rule.groupName,
          finalFieldName: rule.finalFieldName,
          field: rule.field,
          attributename: rule.attributename,
          sourceFieldName: rule.sourceFieldName,
          value: rule.value,
        };

        Object.keys(fieldRule).forEach((key) => {
          if (fieldRule[key] === undefined) {
            delete fieldRule[key];
          }
        });

        result[rule.field] = fieldRule;
      }
    });
  };

  traverseRules(ruleJson.rules);
  return result;
}
